import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function TermsOfService() {
  return (
    <LegalPage title="Terms of Service" updated="August 2026">
      <p>
        These Terms of Service ("Terms") govern your use of the BAT Ear
        Research &amp; Investigations website. By using this site, you agree to
        these Terms. If you do not agree, please do not use the site.
      </p>

      <h2>1. About This Website</h2>
      <p>
        This website is an informational and marketing site for BAT Ear
        Research &amp; Investigations, a licensed private investigation and
        research service based in Accra, Ghana. It describes our services and
        lets you contact us, download free resources, and book a consultation.
      </p>

      <h2>2. No Investigative Engagement Through This Site</h2>
      <p>
        Submitting a contact form, downloading the checklist, or booking a
        consultation does <strong>not</strong> create a client–investigator
        relationship. Any investigative, verification, or settlement work is
        only undertaken after a separate written engagement agreement is
        signed by both parties, scope and fees are agreed, and any required
        retainer is paid.
      </p>

      <h2>3. Free Resources</h2>
      <p>
        Our free pre-investment guide and any other free resources are provided
        for general educational purposes only. They do not constitute legal,
        financial, or investment advice, and they do not guarantee the outcome
        of any transaction. Always obtain independent professional advice
        before wiring funds or signing agreements.
      </p>

      <h2>4. Confidentiality of Enquiries</h2>
      <p>
        We treat all enquiries as private. Information you submit is handled
        according to our{" "}
        <a
          href="/privacy"
          className="text-navy underline decoration-gold underline-offset-4"
        >
          Privacy Policy
        </a>
        . However, until a formal engagement exists, please avoid sending
        highly sensitive documents through the website forms.
      </p>

      <h2>5. Acceptable Use</h2>
      <ul>
        <li>Do not submit false, misleading, or defamatory information.</li>
        <li>
          Do not use this site to request unlawful surveillance or any
          activity prohibited under Ghanaian law.
        </li>
        <li>
          Do not attempt to access the admin area, database, or any
          non-public part of this site.
        </li>
      </ul>

      <h2>6. Third-Party Services</h2>
      <p>
        Consultation booking is handled by Cal.com and chat is handled by
        WhatsApp. Your use of those services is governed by their own terms
        and privacy policies.
      </p>

      <h2>7. Limitation of Liability</h2>
      <p>
        The content of this site is provided "as is" without warranties of any
        kind. To the fullest extent permitted by law, BAT Ear Research &amp;
        Investigations is not liable for any loss arising from reliance on
        website content or free resources. Liability for engaged work is
        governed exclusively by the signed engagement agreement.
      </p>

      <h2>8. Governing Law</h2>
      <p>
        These Terms are governed by the laws of the Republic of Ghana. Any
        disputes shall be subject to the exclusive jurisdiction of the courts
        of Ghana.
      </p>

      <h2>9. Contact</h2>
      <p>
        Questions about these Terms? Email{" "}
        <a
          href="mailto:info@batearghana.com"
          className="text-navy underline decoration-gold underline-offset-4"
        >
          info@batearghana.com
        </a>
        .
      </p>
    </LegalPage>
  );
}
